module.exports = __webpack_public_path__ + "img/image4.77b9a288.webp";